export default __webpack_public_path__ + "static/image-section-seafood-a111a1cd4bfa25153f306e616a88b03a.webp";